import './index.css';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
    removePreparedConstantMenuItems,
    removePreparedMenuItems,
    selectPreparedConstantMenuItems,
    selectPreparedMenuItems
} from '../../app/menuSlice';
import { selectPreparedMenuItemsCount } from '../../app/selectors';
import { ApiError } from '../../api/errors';
import { usePublishMenuItemsMutation } from '../../api/menuApi';
import { modalStyles } from '../../config/modal';
import Modal from 'react-modal';
import { SummaryForPreparedMenuItems } from '../summaryForPreparedMenuItems';

interface IProps {
    cancelEditMode: () => void;
}

export function EditModeWarning({ cancelEditMode }: IProps) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const [isConfirmSubmitModalOpen, setIsConfirmSubmitModalOpen] =
        useState(false);
    const [publishMenuItems] = usePublishMenuItemsMutation();

    const preparedMenuItems = useAppSelector(selectPreparedMenuItems);
    const preparedMenuItemsCount = useAppSelector(selectPreparedMenuItemsCount);
    const preparedConstantMenuItems = useAppSelector(
        selectPreparedConstantMenuItems
    );

    const handleCancelEditMode = useCallback(() => {
        const confirmation = window.confirm(t('confirm_exit'));
        if (confirmation) {
            cancelEditMode();
        }
    }, []);

    const handleSubmitPreparedMenuItems = useCallback(() => {
        Object.keys(preparedMenuItems).forEach((date) => {
            publishMenuItems({
                menuItems: preparedMenuItems[date].map((item) => item.uuid),
                date
            })
                .unwrap()
                .then(() => {
                    dispatch(removePreparedMenuItems());
                })
                .catch((error: unknown) => {
                    if (error instanceof ApiError) {
                        console.log(error.message);
                    }
                });
        });
        if (preparedConstantMenuItems.length > 0) {
            publishMenuItems({
                menuItems: preparedConstantMenuItems.map(
                    (menuItem) => menuItem.uuid
                )
            })
                .unwrap()
                .then(() => {
                    dispatch(removePreparedConstantMenuItems());
                })
                .catch((error: unknown) => {
                    if (error instanceof ApiError) {
                        console.log(error.message);
                    }
                });
        }
    }, [
        preparedMenuItems,
        preparedConstantMenuItems,
        publishMenuItems,
        dispatch
    ]);

    return (
        <div className='edit-mode-warning'>
            {t('edit_mode_warning')}
            <div className='actions'>
                <button
                    className='btn btn-white'
                    onClick={handleCancelEditMode}
                >
                    {t('cancel')}
                </button>
                <button
                    className='btn btn-blue'
                    onClick={() => setIsConfirmSubmitModalOpen(true)}
                    disabled={
                        preparedMenuItemsCount === 0 &&
                        preparedConstantMenuItems.length === 0
                    }
                >
                    {t('confirm')}
                </button>
            </div>
            {isConfirmSubmitModalOpen && (
                <Modal
                    isOpen={isConfirmSubmitModalOpen}
                    style={modalStyles}
                    onRequestClose={() => setIsConfirmSubmitModalOpen(false)}
                    ariaHideApp={false}
                >
                    <SummaryForPreparedMenuItems
                        handleSubmitPreparedMenuItems={
                            handleSubmitPreparedMenuItems
                        }
                        closeModal={() => setIsConfirmSubmitModalOpen(false)}
                    />
                </Modal>
            )}
        </div>
    );
}
